import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const webex = defineConnector({
  identifier: "webex",
  name: "Webex",
  tagLine: "Video conferencing platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://([^/]*\\.)?webexapis\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Webex integration",
      items: [
        {
          kind: "markdown",
          content:
            "Go to [developer.webex.com/my-apps/new](https://developer.webex.com/my-apps/new) and choose **Create an Integration**. Fill in the **Integration name**, **Icon**, and **Description** — Webex requires these but the values don't affect anything here.",
        },
      ],
    },
    {
      title: "Set the redirect URI",
      items: [
        {
          kind: "markdown",
          content:
            "Paste the value below into Webex's mandatory **Redirect URI(s)** field:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/webex/callback",
        },
      ],
    },
    {
      title: "Choose scopes",
      items: [
        {
          kind: "markdown",
          content:
            "Tick the scopes your workflows will need under **Scopes** in Webex. See the [Webex scope reference](https://developer.webex.com/docs/integrations#scopes) for the full list.",
        },
        {
          kind: "input",
          label: "Scopes",
          required: true,
          placeholder: "spark:rooms_read spark:messages_read …",
          target: { kind: "oauthConnection", field: "scopes" },
        },
      ],
    },
    {
      title: "Save and copy your credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Click **Add Integration** in Webex. The page will show your **Client ID** and **Client Secret** — paste them here.",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Webex account",
      items: [
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
            { kind: "oauthConnection", field: "scopes" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://webexapis.com/v1/authorize",
    tokenEndpoint: () => "https://webexapis.com/v1/access_token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://webexapis.com/v1/people/me",
  },
});
